/**
 * 为编辑器生成页面生命周期事件
 * @param {Object} data 项目数据，包括 scenes global
 * @returns {Object} 页面生命周期事件
 */
export default function genPageLifeCycleEvents (data = {}) {
    const pageEvents = {}
    const scenes = data.scenes
    Object.keys(scenes.eventTable).forEach(key => {
        const eventData = scenes.eventTable[key]
        if (!eventData.refId && eventData.isInit) {
            if (pageEvents[eventData.eventName]) {
                pageEvents[eventData.eventName].push(eventData)
            } else {
                pageEvents[eventData.eventName] = [eventData]
            }
        }
    })
    return pageEvents
}
